'use client';

import {useLayoutEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

export function AnimationProvider() {
  useLayoutEffect(() => {
    AOS.init({once: true, duration: 600, mirror: false});
  }, []);

  return <></>;
}
